// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__xIY_M","back":"layout_back__I7uXe"};